exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/core-js/library/modules/_wks-ext.js
// module id = 409
// module chunks = 0